import React, {Component} from 'react'
import PropTypes from 'prop-types'
import BasketCreated from './data/BasketCreated'
import BaskTotalItem from './data/BaskTotalItem'
import BasketCompletedItem from './data/BasketCompletedItem'
import BasketLocation from './data/BasketLocation'
import BasketStatus from './data/BasketStatus'
import BasketOrderNumber from './data/BasketOrderNumber'
import BasketNumber from "./data/BasketNumber"
import classNames from 'classnames'
import BaskItemTypes from "./data/BaskItemTypes"
import humanizeTime from '../../../../helpers/time/humanizeTime'
import BasketPosition from './data/BasketPosition'


class BasketItem extends Component {
    renderTypeBasket = (type = '') => {
        switch(type){
            case 'normal':
                return 'Đơn thường'
            case 'combo_fac':
                return 'Combo FAC'
            case 'combine_ship':
                return 'Gộp ship'
            default:
                return ''
        }
    }

    render() {
        const {basket, onChangeFilterPosition} = this.props
        const {_id: basketId, initialized_at, order_number, number, total_items, completed_items, location, status, item_types, completed_at, position, max_overtime, order_numbers = [], type = ''} = basket
        const completeAt = completed_at ? humanizeTime(completed_at) : '-'

        const isWarning = max_overtime !== null && max_overtime !== undefined && !isNaN(max_overtime) && max_overtime >= -1.5
        const isOvertimed = !!isWarning && max_overtime > 0
        const isAlmostOvertime = !!isWarning && max_overtime >= -1.5 && max_overtime <= 0
        const wraningStyle = !!isWarning ? { background: `rgb(${(!!isAlmostOvertime ? "255, 208, 26, 0.3" : (isOvertimed ? "223, 31, 31, 0.2" : ''))})` } : {}

        return (
            <tr className={classNames('BasketItem', status, location)} style={wraningStyle}>
                <BasketNumber id={basketId} number={number}/>
                <BasketOrderNumber orderNumber={order_number} orderNumbers={order_numbers}/>
                <BaskItemTypes types={item_types}/>
                <BasketPosition position={position} onChangeFilterPosition={onChangeFilterPosition}/>
                <BaskTotalItem totalItems={total_items}/>
                <td>{!!type && this.renderTypeBasket(type)}</td>
                <BasketCompletedItem totalItems={total_items} completedItems={completed_items}/>
                <BasketLocation location={location}/>
                <BasketStatus status={status}/>
                <BasketCreated created={initialized_at}/>
                <td>{completeAt}</td>
            </tr>
        )
    }
}

BasketItem.propTypes = {
    basket: PropTypes.object.isRequired,
}

export default BasketItem
